"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApexService = void 0;
const axios_1 = __importDefault(require("axios"));
const networks_1 = require("./networks");
const base_network_service_1 = require("./base-network.service");
const ethers_1 = require("ethers");
const url = __importStar(require("url"));
class ApexService extends base_network_service_1.BaseNetworkService {
  constructor(chainId, urls, websocketRpcUrls = [], logger) {
    if (!networks_1.ApexNetworks.includes(chainId)) {
      throw new Error(`The given chainId [${chainId}] is not supported by Apex network`);
    }
    super(chainId, urls, websocketRpcUrls, logger);
  }
  getName() {
    return `apex_${this.name}`;
  }
  async fetchTransactions(contractAddress, fromBlockNumber, tillBlockNumber, fetchSize, sort = 'asc', page = 1, timeout = 60000) {
    // TODO BLOC-1209 api is not correct
    const transactions = await axios_1.default.get(`https://api.theapexchain.org/api?module=account&action=txlist&address=${contractAddress}&startblock=${fromBlockNumber}&endblock=${tillBlockNumber}&page=${page}&offset=${fetchSize.toString()}&sort=${sort}&apikey=PGKWEA8K86K64PAYRHRDBSDMF37MEH9ZQT`, {
      timeout: timeout,
      timeoutErrorMessage: 'Fetching transactions timeout'
    });
    return transactions.data;
  }
  async fetchTransactionReceipt(transactionHash) {
    try {
      // TODO BLOC-1209 api is not correct
      const receipt = await axios_1.default.get(`https://api.theapexchain.org/api?module=proxy&action=eth_getTransactionReceipt&txhash=${transactionHash}&apikey=PGKWEA8K86K64PAYRHRDBSDMF37MEH9ZQT`, {
        timeout: 60000,
        timeoutErrorMessage: 'Fetching event logs timeout'
      });
      if (receipt.data.result) {
        return receipt.data.result;
      }
    } catch (error) {
      this.logger.error(`An error occurred while getting transaction receipt [${transactionHash}] on Polygon, error ${JSON.stringify(error)}`);
    }
    return super.fetchTransactionReceipt(transactionHash);
  }
  async fetchLogsByCallingApiAxiosResponse(contractAddress, eventSignature, topics, fromBlockNumber, tillBlockNumber) {
    const eventTopic = eventSignature ? ethers_1.ethers.utils.id(eventSignature) : null;
    let url = ApexService.API_BASE_URL;
    url += `?` + `apikey=${ApexService.API_KEY}`;
    url += `&` + `module=logs`;
    url += `&` + `action=getLogs`;
    url += `&` + `address=${contractAddress}`;
    if (eventTopic) {
      url += `&` + `topic0=${eventTopic}`;
    }
    if (topics['1']) {
      url += `&` + `topic1=${topics['1']}`;
    }
    if (topics['2']) {
      url += `&` + `topic2=${topics['2']}`;
    }
    if (topics['3']) {
      url += `&` + `topic3=${topics['3']}`;
    }
    if (fromBlockNumber) {
      url += `&` + `fromBlock=${fromBlockNumber}`;
    }
    if (tillBlockNumber) {
      url += `&` + `toBlock=${tillBlockNumber}`;
    }
    const response = await axios_1.default.get(url, {
      timeout: 60000,
      timeoutErrorMessage: 'Fetching event log timeout'
    });
    if (response.status != 200) {
      throw new Error(`Exception in fetchLogsFromApi. chainId: ${this.chainId}, status code:${response.status}`);
    }
    return response;
  }
  async fetchLogsByCallingApi(contractAddress, abi, eventSignature, topics, fromBlockNumber, tillBlockNumber) {
    const response = await this.fetchLogsByCallingApiAxiosResponse(contractAddress, eventSignature, topics, fromBlockNumber, tillBlockNumber);
    const interface_ = new ethers_1.ethers.utils.Interface(abi);
    const logs = response.data.result.map(rawLog => {
      const log = interface_.parseLog(rawLog);
      return {
        blockNumber: rawLog.blockNumber,
        timeStamp: rawLog.timeStamp,
        transactionHash: rawLog.transactionHash,
        args: log.args
      };
    });
    return logs;
  }
  async fetchTokensTransfers(address, contractAddress, fromBlockNumber, tillBlockNumber, sort = 'desc', page = 1, fetchSize = 10, timeout = 60000) {
    const request = {
      module: 'account',
      action: 'tokentx',
      address: address,
      startblock: fromBlockNumber,
      endblock: tillBlockNumber,
      page: page,
      offset: fetchSize,
      sort: sort,
      apikey: ApexService.API_KEY
    };
    if (contractAddress) {
      request.contractaddress = contractAddress;
    }
    const params = new url.URLSearchParams(request);
    const transactions = await axios_1.default.get(`https://api.theapexchain.org/api?${params}`, {
      timeout: timeout,
      timeoutErrorMessage: 'Fetching erc20 token transfers timeout'
    });
    return transactions.data;
  }
}
exports.ApexService = ApexService;
ApexService.API_BASE_URL = 'https://api.theapexchain.org/api';
ApexService.API_KEY = 'PGKWEA8K86K64PAYRHRDBSDMF37MEH9ZQT';
